/**
 * Andre Garen - Faz 8 Süsleme Paket 1, madde 02 (15 Eylul).
 * Urun karti ici galeri: ray kaydirildikca ilerleme cizgilerini
 * gunceller. Kart basina ayri bir listener EKLEMEZ - 'scroll' olayi
 * bubble'lamaz ama capture fazinda ust elemanlarda YAKALANABILIR, bu
 * yuzden tek bir document-level capture listener tum ray'ler icin yeterli
 * (spec: "scroll listener passive:true olsun", tek yerden yonetim).
 */
(function () {
  'use strict';

  function updateDots(rail) {
    var media = rail.parentElement;
    var dots = media ? media.querySelectorAll('.ag-card__dot') : [];
    if (!dots.length) return;
    var idx = Math.round(rail.scrollLeft / rail.clientWidth);
    dots.forEach(function (dot, i) {
      if (i === idx) dot.setAttribute('data-active', '');
      else dot.removeAttribute('data-active');
    });
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var rail = e.target && e.target.closest && e.target.closest('[data-ag-card-rail]');
      if (rail) updateDots(rail);
    },
    { capture: true, passive: true }
  );
})();

/* Tur 23 EK1 K6: kart renk noktalari - dokununca kart gorseli o rengin varyant gorseline gecer (varsa),
   ray basa doner (ilerleme cizgileri yukaridaki scroll dinleyicisiyle guncellenir). Tek document dinleyicisi. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ag-card-color]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('.ag-card');
    if (!card) return;
    Array.prototype.forEach.call(card.querySelectorAll('[data-ag-card-color]'), function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    /* Tur 23 EK3F: kart baglantisi (gorsel + ad) secilen rengin varyantina gider (?variant=, urun sayfasi o renkle acilir). */
    var vid = b.getAttribute('data-ag-variant');
    if (vid) {
      Array.prototype.forEach.call(card.querySelectorAll('a.ag-card__link'), function (a) {
        try {
          var u = new URL(a.getAttribute('href'), location.href);
          u.searchParams.set('variant', vid);
          a.setAttribute('href', u.pathname + u.search + u.hash);
        } catch (err) {}
      });
    }
    var src = b.getAttribute('data-ag-img');
    var img = card.querySelector('.ag-card__railimg, .ag-card__img');
    if (!src || !img) return;
    img.removeAttribute('loading');
    img.setAttribute('srcset', b.getAttribute('data-ag-srcset') || '');
    img.setAttribute('src', src);
    var rail = card.querySelector('[data-ag-card-rail]');
    if (rail && rail.scrollLeft) rail.scrollTo({ left: 0 });
  });
})();
